import { cn } from '../../../lib';
import { TSvgComponentProps } from '../../../types';

export interface ILogoNorthLadderProps extends TSvgComponentProps {
  isInverted?: boolean;
  height?: number;
}

/**
 * -----------------------------------------------------------------------------
 * The NorthLadder logo as a customizable SVG Element to be used across the app.
 */
export function LogoNorthLadder({
  isInverted,
  version,
  ...props
}: ILogoNorthLadderProps) {
  const classBody = cn(
    isInverted ? 'fill-purple-400' : 'fill-purple-900 dark:fill-purple-400',
    version === 'v2' && 'fill-white dark:fill-purple-200'
  );
  const classHighlight = cn(
    isInverted ? 'fill-purple-50' : 'fill-purple-300  dark:fill-purple-50'
  );

  return (
    <svg
      id="northladder-logo-light"
      viewBox="0 0 264 24"
      x={0}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      y={0}
      {...props}
    >
      <g id="North_4_">
        <path
          className={classBody}
          d="M12.8 14 4.3 3.3H1.6v17.3h3.2V8.9L14 20.6h2V3.3h-3.2V14z"
          id="N_4_"
        />
        <path
          className={classBody}
          d="M34.3 3c-6 0-8.9 4.5-8.9 9.1s2.8 8.9 8.9 8.9 8.8-4.4 8.9-8.9c0-4.6-3.1-9.1-8.9-9.1zm0 3c4.1 0 5.7 3.2 5.6 6.2 0 2.8-1.6 5.8-5.6 5.8s-5.6-3-5.6-5.8c-.1-3 1.5-6.2 5.6-6.2z"
          id="O_4_"
        />
        <path
          className={classBody}
          d="m67.7 20.4-5.2-5.8c3.2-.6 4.3-3 4.3-5.4 0-3-2.2-5.7-6.2-5.7h-8.2v17.2h3.2V15h3.1l5 5.7h3.9c.1-.1.1-.3.1-.3zm-7-14.1c2.1 0 2.9 1.4 2.9 2.8s-.9 2.8-2.9 2.8h-5V6.3h5z"
          id="R_8_"
        />
        <path
          className={classBody}
          d="M81.3 20.6h3.2V6.3H90v-3H75.8v2.9h5.5v14.4z"
          id="T_4_"
        />
        <path
          className={classBody}
          d="M113.8 20.6V3.4h-3.2v7.2h-8.4V3.4H99v17.2h3.2v-6.9h8.4v6.9h3.2z"
          id="H_4_"
        />
      </g>
      <g id="Ladder_4_">
        <path
          className={classBody}
          d="M128.8 3.3v17.3h12.1v-3H132V3.3h-3.2z"
          id="L_4_"
        />
        <g id="A-NorthCompass_4_">
          <path
            className={classBody}
            d="m158.3 3.2 9.8 18.4-10.3-4.7-10.3 4.7 10.3-19.2.5.8zm-.4 1.3-8 15 8-3.7V4.5z"
            id="A-Background_4_"
          />
          <path
            className={classHighlight}
            d="M157.9 15.8V4.5l-8 15 8-3.7z"
            id="A-Highlight_4_"
          />
        </g>
        <path
          className={classBody}
          d="M182.9 3.3h-6.8v17.3h6.8c6.1 0 8.7-4.4 8.7-8.8-.2-4.3-2.8-8.5-8.7-8.5zm-3.6 3.1h3.6c3.8 0 5.3 2.7 5.4 5.4.1 2.8-1.5 5.6-5.4 5.6h-3.6v-11z"
          id="D1_4_"
        />
        <path
          className={classBody}
          d="M207.1 3.3h-6.8v17.3h6.8c6.1 0 8.7-4.4 8.7-8.8-.2-4.3-2.8-8.5-8.7-8.5zm-3.5 3.1h3.6c3.8 0 5.3 2.7 5.4 5.4.1 2.8-1.5 5.6-5.4 5.6h-3.6v-11z"
          id="D2_4_"
        />
        <g id="E-Ladder_4_">
          <g id="Step1_4_">
            <path
              className={classBody}
              d="M220.1 20.5h12.6v-2.9h-12.6v2.9z"
              id="Step1-Base_4_"
            />
            <path
              className={classHighlight}
              d="M222.7 15.8h12.6l-2.6 1.6h-12.6l2.6-1.6z"
              id="Step1-Top_4_"
            />
          </g>
          <g id="Step-2_4_">
            <path
              className={classBody}
              d="M223.6 14.2h12.6v-2.9h-12.6v2.9z"
              id="Step2-Base_4_"
            />
            <path
              className={classHighlight}
              d="M226.2 9.7h12.6l-2.6 1.6h-12.6l2.6-1.6z"
              id="Step2-Top_4_"
            />
          </g>
          <g id="Step3_4_">
            <path
              className={classBody}
              d="M227.3 8.1h12.6v-3h-12.6v3z"
              id="Step3-Base_4_"
            />
            <path
              className={classHighlight}
              d="M229.9 3.4h12.6L239.9 5h-12.6l2.6-1.6z"
              id="Step3-Top_4_"
            />
          </g>
        </g>
        <path
          className={classBody}
          d="m262.4 20.4-5.2-5.8c3.2-.6 4.3-3 4.3-5.4 0-3-2.2-5.7-6.2-5.7h-8.2v17.2h3.2V15h3.1l5 5.7h3.9v-.3h.1zm-7.1-14.1c2.1 0 2.9 1.4 2.9 2.8s-.9 2.8-2.9 2.8h-5V6.3h5z"
          id="R_7_"
        />
      </g>
    </svg>
  );
}
